<template>
    <v-container fluid>
        <!-- <v-row>

            <v-col cols="12" sm="4">
                <v-card class="pa-5 rounded-xl align-self-center" elevation="3" max-width="350" height="100%">
                    <div class="d-flex flex-column align-center justify-center h-100">
                        <div class="text-overline text-center mb-5">{{$t('ordersThisMonthLabel')}}</div>
                        <div class="text-h3 font-weight-bold">{{orders}}</div>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card class="pa-5 mx-auto rounded-xl align-self-center" elevation="3" max-width="350" height="100%">
                    <div class="d-flex flex-column align-center justify-center h-100">
                        <div class="text-overline text-center mb-5">{{$t('spcCompaniesLabel')}}</div>
                        <div class="text-h3 font-weight-bold">{{salesPartnershipCompanies}}</div>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card class="pa-5 ml-auto rounded-xl align-self-center" elevation="3" max-width="350" height="100%">
                    <v-card-title class="text-overline text-center justify-center">
                        {{$t('notesLabel')}}
                    </v-card-title>
                    <v-data-table :hide-default-header="true" :hide-default-footer="true" :headers="notesList.headers" :items="notesList.notes">
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="12" sm="8">
                <v-card class="rounded-xl align-self-center pa-12 mb-5" elevation="3" height="auto" >
                    <v-card-title class="text-h5">
                        Product Orders
                        <v-spacer></v-spacer>
                        <v-text-field v-model="ordersTable.search" dense outlined append-icon="mdi-magnify" :label="$t('searchLabel')" single-line
                            hide-details>
                        </v-text-field>
                    </v-card-title>
                    <v-data-table :headers="ordersTable.headers" :items="ordersTable.productOrders"
                        :search="ordersTable.search">
                    </v-data-table>
                </v-card>
                <v-card class="rounded-xl align-self-center pa-12" elevation="3" height="auto">
                    <v-card-title class="text-h5">
                        {{$t('protocolLabel')}}
                        <v-spacer></v-spacer>
                    </v-card-title>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4">
                <v-card class="pa-12 rounded-xl align-self-center" elevation="3" height="100%">
                    <div class="d-flex align-center justify-center flex-column h-100">
                        <div class="text-h5 text-center mb-5">Companies</div>
                        <v-spacer></v-spacer>
                    </div>
                    <v-card-title class="ma-0 pt-0 text-overline">
                        
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
<!--            <v-col cols="12" v-if="orders.init">-->
<!--                <v-card class="pa-5 rounded-xl align-self-center" elevation="3" height="100%">-->
<!--                    <v-card-title class="justify-center text-h5">-->
<!--                        {{ $t("ordersLabel") }}-->
<!--                    </v-card-title>-->
<!--                    <OrdersTable :companyId="parseInt(orders.companyId)" :userId="parseInt(orders.userId)"-->
<!--                        :canEdit="orders.canEdit" :getByUser="orders.getByUser" :getByCompany="orders.getByCompany"-->
<!--                        :canFilterByCompany="orders.canFilterByCompany" />-->
<!--                </v-card>-->
<!--            </v-col>-->
            <v-col cols="12" v-if="products.init">
                <v-card class="pa-5 rounded-xl align-self-center" elevation="3" height="100%">
                    <v-card-title class="justify-center text-h5">
                        {{ $t("productConfigurationsLabel") }}
                    </v-card-title>

                    <ProductConfigurationsTable :companyId="parseInt(products.companyId)" :userId="parseInt(products.userId)"
                        :canAddNew="products.canAddNew" :canEdit="products.canEdit" :getByUser="products.getByUser"
                        :getByCompany="products.getByCompany" :includeAffiliates="products.includeAffiliates" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import OrdersTable from "../components/OrdersTable";
import ProductConfigurationsTable from "../components/ProductConfigurationsTable";
import UserTypes from "../auth/userTypes";

    export default {
        data() {
            return {
                orders: {
                    init: true,
                    companyId: 0,
                    userId: 0,
                    canEdit: false,
                    getByUser: false,
                    getByCompany: false,
                    canFilterByCompany: false,
                },
                products: {
                    init: false,
                    companyId: 0,
                    userId: 0,
                    canAddNew: false,
                    canEdit: false,
                    getByUser: false,
                    getByCompany: false,
                    includeAffiliates: false,
                },
                // orders: 457,
                // salesPartnershipCompanies: 20,
                notesList: {
                    headers: [{
                        text: '',
                        sortable: false,
                        value: 'name',
                    }, ],
                    notes: [{
                            name: 'Lorem Ipsum',
                        },
                        {
                            name: 'Lorem Ipsum',
                        },
                    ],
                },
                ordersTable: {
                    search: '',
                    headers: [{
                            text: 'Order Name',
                            align: 'start',
                            sortable: true,
                            value: 'name',
                        },
                        {
                            text: 'Status',
                            align: 'center',
                            value: 'status'
                        },
                        {
                            text: '',
                            sortable: false,
                            align: 'end',
                            value: 'empty'
                        },
                    ],
                    productOrders: [{
                            name: 'Order 1',
                            status: 'Completed',
                            empty: 'Show More'
                        },
                        {
                            name: 'Order 2',
                            status: 'Completed',
                            empty: 'Show More'
                        },
                        {
                            name: 'Order 3',
                            status: 'Uncompleted',
                            empty: 'Show More'
                        },
                        {
                            name: 'Order 4',
                            status: 'Completed',
                            empty: 'Show More'
                        },
                        {
                            name: 'Order 5',
                            status: 'Uncompleted',
                            empty: 'Show More'
                        },
                        {
                            name: 'Order 6',
                            status: 'Uncompleted',
                            empty: 'Show More'
                        },
                    ],
                }
            }
        },
        components: {
            OrdersTable,
            ProductConfigurationsTable,
        },
        methods: {
            initOrdersTable() {
                var userType = this.$store.state.user.userType;

                if (userType == UserTypes.WertheimAdministrator) {
                    this.orders.companyId = this.$store.state.user.companyId;
                    (this.orders.userId = this.$store.state.user.userId),
                    (this.orders.canEdit = true),
                    (this.orders.getByUser = false),
                    (this.orders.getByCompany = false);
                    this.orders.canFilterByCompany = true;
                }
                if (userType == UserTypes.WertheimSales) {
                    this.orders.companyId = this.$store.state.user.companyId;
                    this.orders.userId = this.$store.state.user.userId;
                    (this.orders.canEdit = true),
                    (this.orders.getByUser = false),
                    (this.orders.getByCompany = false);
                    this.orders.canFilterByCompany = true;
                }
                if (userType == UserTypes.SalesPartnershipAdmin) {
                    this.orders.companyId = this.$store.state.user.companyId;
                    this.orders.userId = this.$store.state.user.userId;
                    (this.orders.canEdit = true), (this.orders.getByUser = false);
                    this.orders.getByCompany = true;
                    this.orders.canFilterByCompany = false;
                }
                if (userType == UserTypes.SalesPartnershipSales) {
                    this.orders.companyId = this.$store.state.user.companyId;
                    this.orders.userId = this.$store.state.user.userId;
                    (this.orders.canEdit = true), (this.orders.getByUser = true);
                    this.orders.getByCompany = false;
                    this.orders.canFilterByCompany = false;
                }
                if (userType == UserTypes.SalesPartnershipProductConfigurator) {
                    this.orders.init = false;
                    // this.orders.companyId = this.$store.state.user.companyId;
                    // this.orders.userId = this.$store.state.user.userId;
                    // (this.orders.canEdit = true), (this.orders.getByUser = true);
                    // this.orders.getByCompany = false;
                    // this.orders.canFilterByCompany = false;

                }
                if (userType == UserTypes.AffiliatePartnershipSales) {
                    this.orders.init = false;
                    // this.orders.companyId = this.$store.state.user.companyId;
                    // this.orders.userId = this.$store.state.user.userId;
                    // (this.orders.canEdit = true), (this.orders.getByUser = true);
                    // this.orders.getByCompany = false;
                    // this.orders.canFilterByCompany = false;
                }
            },
            initProductConfigurationsTable() {
                this.products.init = true;
                var userType = this.$store.state.user.userType;

                if (userType == UserTypes.WertheimAdministrator) {
                    this.products.companyId = this.$store.state.user.companyId;
                    (this.products.userId = this.$store.state.user.userId),
                    (this.products.canAddNew = true),
                    (this.products.canEdit = true),
                    (this.products.getByUser = false),
                    (this.products.getByCompany = false),
                    (this.products.includeAffiliates = false);
                }
                if (userType == UserTypes.WertheimSales) {
                    this.products.companyId = this.$store.state.user.companyId;
                    this.products.userId = this.$store.state.user.userId;
                    (this.products.canAddNew = true),
                    (this.products.canEdit = true),
                    (this.products.getByUser = false),
                    (this.products.getByCompany = false),
                    (this.products.includeAffiliates = false);
                }
                if (userType == UserTypes.SalesPartnershipAdmin) {
                    this.products.companyId = this.$store.state.user.companyId;
                    this.products.userId = this.$store.state.user.userId;
                    (this.products.canAddNew = true),
                    (this.products.canEdit = true),
                    (this.products.getByUser = false),
                    (this.products.getByCompany = true),
                    (this.products.includeAffiliates = true);
                }
                if (userType == UserTypes.SalesPartnershipSales) {
                    this.products.companyId = this.$store.state.user.companyId;
                    this.products.userId = this.$store.state.user.userId;
                    (this.products.canAddNew = true),
                    (this.products.canEdit = true),
                    (this.products.getByUser = true),
                    (this.products.getByCompany = false),
                    (this.products.includeAffiliates = false);
                }
                if (userType == UserTypes.SalesPartnershipProductConfigurator) {
                    this.products.companyId = this.$store.state.user.companyId;
                    this.products.userId = this.$store.state.user.userId;
                    (this.products.canAddNew = true),
                    (this.products.canEdit = true),
                    (this.products.getByUser = true),
                    (this.products.getByCompany = false),
                    (this.products.includeAffiliates = false);
                }
                if (userType == UserTypes.AffiliatePartnershipSales) {
                    this.products.companyId = this.$store.state.user.companyId;
                    this.products.userId = this.$store.state.user.userId;
                    (this.products.canAddNew = true),
                    (this.products.canEdit = true),
                    (this.products.getByUser = true),
                    (this.products.getByCompany = false),
                    (this.products.includeAffiliates = false);
                }
            },
        },
        mounted() {
            this.initOrdersTable();
            this.initProductConfigurationsTable();
        },
    }
</script>

<style lang="scss" scoped>
    .list-item {
        border: 1px solid rgb(224, 224, 224);
    }

    .h-100 {
        height: 100%;
    }

    .w-100 {
        width: 100%;
    }
</style>